const BASE_URL = process.env.REACT_APP_API_URL || 'https://crm.mmachine.pro';
module.exports = BASE_URL;
